import Request from "./Request";

export default class App {
    constructor() {
        this.controllers = {};
        this.events = ['click', 'select', 'change', 'keyup', 'keydown', 'keypress', 'submit', 'focus', 'blur', 'paste'];
    }

    run() {
        document.querySelectorAll('[app-controller]').forEach(el => {
            let controllerName = el.getAttribute('app-controller');
            this.refresh(controllerName, el);
        });

        Object.keys(this.controllers).forEach(key => {
            if (typeof this.controllers[key]['run'] === 'function') {
                this.controllers[key].run();
            }
        });
    }

    refresh(controllerName, el) {
        el = el || document.querySelector('[app-controller=' + controllerName + ']');

        let controller;
        if (this.controllers[controllerName] === undefined || el.dataset.store === 'false') {
            controller = this.getClass(controllerName);
            if (controller === null) {
                return;
            }
        } else {
            controller = this.controllers[controllerName];
        }

        let elements = Array.from(el.querySelectorAll('[app-name]')).reduce((obj, item) => {
            obj[item.getAttribute('app-name')] = item;
            return obj;
        }, {});
        elements['app_container'] = el;
        controller.init(this, controllerName, elements, el.dataset);

        let selectors = this.events.map(event => {
            return '[app-' + event + ']';
        }).join(',');

        el.querySelectorAll(selectors).forEach(item => {
            if (typeof controller[this.getActionAttribute(item)] === 'function') {
                item[this.getActionEvent(item)] = e => {
                    controller[this.getActionAttribute(item)](e, item);
                };
            }
        });

        if (el.dataset.store === 'false') {
            controller.run();
        } else {
            this.controllers[controllerName] = controller;
        }
    }

    registerCallback(controllerName, callbackName, callback) {
        if (typeof this.controllers[controllerName] === 'object') {
            this.controllers[controllerName].callbacks[callbackName] = data => {
                return callback(data);
            };
        }
    }

    getController(controllerName) {
        if (typeof this.controllers[controllerName] === 'object') {
            return this.controllers[controllerName];
        }

        return null;
    }

    getActionAttribute(item) {
        for (let i = 0; i < this.events.length; i++) {
            if (item.hasAttribute('app-' + this.events[i])) {
                return item.getAttribute('app-' + this.events[i]);
            }
        }
    }

    getActionEvent(item) {
        for (let i = 0; i < this.events.length; i++) {
            if (item.hasAttribute('app-' + this.events[i])) {
                return 'on' + this.events[i];
            }
        }
    }

    getClass(className) {
        return new (window.controllers[className])();
    }

    getRequest(url, params, method) {
        return new Request(url, params, method);
    }
}